"use client";

import { CenterPageLoader } from "@offstreetparking/design-system/feedback";
import { ResponsiveOverlay } from "@offstreetparking/portal-flow/components/overlays/ResponsiveOverlay";
import { useEffect, useState } from "react";

type LegalContentModalProps = {
	isOpen: boolean;
	onClose: () => void;
	title: string;
	url: string;
};

export const LegalContentModal = ({ isOpen, onClose, title, url }: LegalContentModalProps) => {
	const [iframeState, setIframeState] = useState<"loading" | "loaded">("loading");

	useEffect(() => {
		if (isOpen) {
			setIframeState("loading");
		}
	}, [isOpen]);

	const handleIframeLoad = () => {
		setIframeState("loaded");
	};

	return (
		<ResponsiveOverlay isOpen={isOpen} onOpenChange={(open) => !open && onClose()} title={title}>
			<div className="relative h-[60vh] w-full overflow-hidden">
				{iframeState === "loading" && (
					<div aria-busy="true" aria-live="polite" className="absolute inset-0 z-10">
						<CenterPageLoader />
					</div>
				)}
				<iframe
					title={title}
					src={url}
					onLoad={handleIframeLoad}
					className="-top-[120px] absolute h-[calc(100%+120px+1100px)] w-full border-0"
					sandbox="allow-scripts allow-same-origin"
				/>
			</div>
		</ResponsiveOverlay>
	);
};
